// packages/whiteboard/src/optionsbar/parts/options-circle-parts.ts
//
// Baukasten für die Optionskreise: jedes Teil (part1 … part10) liegt genau
// EINMAL als SVG-Datei vor und wird pro Werkzeug nur aus den benötigten Teilen
// zusammengesetzt (siehe compose-options-circle.ts). Dadurch landet jedes Teil
// nur einmal im Bundle, statt in jeder Werkzeug-SVG erneut.
//
// Inhalt der Teile (Stand: Anke, 2026-07):
//   part1  Standard-Knöpfe (undo/redo, kopieren/einfügen/ausschneiden,
//          löschen, vor/zurück) — steckt in JEDEM Werkzeug.
//   part2  Rahmenfarben (31) + Füll-Optionen (Schatten/Deckkraft) +
//          Linien-Optionen (Strichart/Strichstärke).
//   part3  Füllfarben (31).
//   part4  Text-Ausrichtung, Groß-/Kleinschreibung, Listen.
//   part5  Eckenrundung.
//   part6  Personen-Marker.
//   part7  Linienenden (Punkt/Pfeil/Quadrat je Seite) + Enden tauschen +
//          Linienführung (gerade / rechtwinklig / Bezier).
//   part8  Smiley-Motiv-Picker (22 Icons: icon1 … icon22).
//   part9  Checkbox-Größen (S/M/L) + Checkbox-Icon-Auswahl (Haken/Kreuz/
//          Smiley) — Stefan, 2026-08-29.
//   part10 Schriftgrößen + Textfarben (31) + Textoptionen.

import part1 from './part1.svg?raw';
import part2 from './part2.svg?raw';
import part3 from './part3.svg?raw';
import part4 from './part4.svg?raw';
import part5 from './part5.svg?raw';
import part6 from './part6.svg?raw';
import part7 from './part7.svg?raw';
import part8 from './part8.svg?raw';
import part9 from './part9.svg?raw';
import part10 from './part10.svg?raw';

/** Roh-SVG je Teil-Nummer. Schlüssel = Nummer im Dateinamen (`partN.svg`). */
export const OPTIONS_CIRCLE_PARTS: Readonly<Record<number, string>> = {
  1: part1,
  2: part2,
  3: part3,
  4: part4,
  5: part5,
  6: part6,
  7: part7,
  8: part8,
  9: part9,
  10: part10,
};
